export const locale = {
    lang: 'en',
    data: {
        exportSettings: {
            common: {
                yes: 'OK',
                no: 'Cancel',
                confirmation: 'Confirmation'
            },
            scopes: {
                exportSettings: {
                    fields: {
                        otherSettings: {
                            includeLineLevelInvoiceExport: {
                                label: 'Include Line Level'
                            }
                        },
                        exportSettings: {
                            companyName: {
                                userColumnName: {label: 'Company Name'}
                            },
                            emailAddress: {
                                userColumnName: {label: 'Email Address'}
                            },
                            poAddressLine1: {
                                userColumnName: {label: 'PO Address Line 1'}
                            },
                            poAddressLine2: {
                                userColumnName: {label: 'PO Address Line 2'}
                            },
                            poAddressLine3: {
                                userColumnName: {label: 'PO Address Line 3'}
                            },
                            poAddressLine4: {
                                userColumnName: {label: 'PO Address Line 4'}
                            },
                            poCounty: {
                                userColumnName: {label: 'PO County'}
                            },
                            poPostalCode: {
                                userColumnName: {label: 'PO Postal Code'}
                            },
                            poCountry: {
                                userColumnName: {label: 'PO Country'}
                            },
                            invoiceNumber: {
                                userColumnName: {label: 'Invoice Number'}
                            },
                            invoiceDate: {
                                userColumnName: {label: 'Invoice Date'}
                            },
                            inventoryItemCode: {
                                userColumnName: {
                                    label: 'Inventory Item Code'
                                }
                            },
                            description: {
                                userColumnName: {label: 'Description'}
                            },
                            rate: {
                                userColumnName: {label: 'Rate'}
                            },
                            accountCode: {
                                userColumnName: {label: 'Account Code'}
                            },
                            taxType: {
                                userColumnName: {label: 'VAT Type'}
                            },
                            taxAmount: {
                                userColumnName: {label: 'VAT Amount'}
                            },
                            currency: {
                                userColumnName: {label: 'Currency'}
                            }
                        }
                    }
                }
            },
            pages: {
                exportSettings: {
                    heading: 'Change Export Settings',
                    columns: {
                        defaultColumnName: 'Default Name',
                        userColumnName: 'Current Name',
                        include: 'Include'
                    }
                },
                createEdit: {
                    buttons: {
                        save: 'SAVE',
                        add: 'SAVE',
                        cancel: 'CANCEL'
                    }
                }
            },
            messages: {}
        }
    }
};
